
import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderItem, SapProduct } from '@/api/model';

interface Totals {
  [key: string]: number;
}

@Component
export default class OrderTotals extends Vue {
  @Prop(Array)
  items!: OrderItem[];

  @Prop(Array)
  products!: SapProduct[];

  @Prop(String)
  label!: string;

  showWeight = true;

  get totals(): any {
    const totals: Totals = {
      pal: 0,
      lay: 0,
      car: 0,
      netWeight: 0,
      grossWeight: 0,
    };
    const reducer = (acc: Totals, item: OrderItem) => {
      if (item.SalesUnit !== undefined && item.SalesUnit !== null) {
        const unit = item.SalesUnit.toLowerCase();
        const weightUnits = this.weightUnits(item.ProductNr, item.SalesUnit);
        if (weightUnits.netWeight === 0 || weightUnits.grossWeight === 0) {
          this.showWeight = false;
        }
        if (item.Quantity !== undefined && item.Quantity !== null) {
          const quantity = parseInt(item.Quantity, 10);
          acc[unit] += quantity;
          acc.netWeight += weightUnits.netWeight * quantity;
          acc.grossWeight += weightUnits.grossWeight * quantity;
        }
      }
      return acc;
    };
    this.showWeight = true;
    return this.items.reduce(reducer, totals);
  }

  weightUnits(
    productNr: any,
    salesUnit: string,
  ): {
    netWeight: number;
    grossWeight: number;
  } {
    if (this.products) {
      const product = this.products.find(
        (prod) => prod.ProductNr === productNr,
      );
      if (product && product.Units) {
        const selectedUnit = product.Units.find(
          (unit) => unit.UnitOfMeasure === salesUnit,
        );
        if (selectedUnit) {
          return {
            netWeight: selectedUnit.NetWeight
              ? parseInt(selectedUnit.NetWeight, 10)
              : 0,
            grossWeight: selectedUnit.GrossWeight
              ? parseInt(selectedUnit.GrossWeight, 10)
              : 0,
          };
        }
      }
    }

    return {
      netWeight: 0,
      grossWeight: 0,
    };
  }
}
